"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Hidden;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// v4 Hidden, after the v5 breakpoint codemod. `down` props are exclusive.
function Hidden(_ref) {
  var smUp = _ref.smUp,
    smDown = _ref.smDown,
    mdDown = _ref.mdDown,
    children = _ref.children;
  var sx = {};
  if (smUp) {
    sx = {
      display: {
        sm: "none"
      }
    };
  } else if (mdDown) {
    sx = {
      display: {
        xs: "none",
        md: "block"
      }
    };
  } else if (smDown) {
    sx = {
      display: {
        xs: "none",
        sm: "block"
      }
    };
  }
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    sx: sx
  }, children);
}